import {defineMessages} from 'react-intl';

export const guideMessages = defineMessages({
  scrollIndicatorButtonLabel: { id: 'guide.scroll_indicator_button_label' },
  scrollIndicatorDescription: { id: 'guide.scroll_indicator_description' },
  scrollIndicatorTitle: { id: 'guide.scroll_indicator_title' },
});
